import { clsx } from "clsx";
import React, { ReactElement, ReactNode } from "react";
import { Helmet } from "react-helmet";


interface IPageWrapperProps {
    children: JSX.Element | ReactElement | ReactNode | null;
    title?: string;
    className?: ReactNode | null;
}

function Page({ children, title, className }: IPageWrapperProps) {
    const appName = process.env.APP_NAME ?? "Korabia";

    return (
        <div className={clsx("bg-white dark:bg-slate-900 p-4 md:p-6 rounded-md min-h-screen", className)}>
            <Helmet >
                <title>{appName} - {title}</title>
            </Helmet>

            {children}
        </div>
    );
}

export default Page;
